import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { Badge } from '@morressier/alembic';

type IProps = {
  value: string[];
};

export const TagInputDisplay: React.FC<IProps> = ({ value }) => {
  return (
    <Flex flexDirection="column" gap={2}>
      <Flex gap={1} wrap="wrap" width="100%">
        {value.map(keyword => (
          <Badge size="context" key={keyword} maxW="100%">
            <Box whiteSpace="normal" wordBreak="break-word">
              {keyword}
            </Box>
          </Badge>
        ))}
      </Flex>
    </Flex>
  );
};
